const CalendarPage  = () => {
  return <> Calendar Page</>;
};

export default CalendarPage;